module.exports = __webpack_public_path__ + "img/Volumes.d769ca6.svg";